import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { CountryActions } from './country.actions';
import { CountryEntity } from './country.entity';

export const COUNTRY_FEATURE_KEY = 'country';

export interface CountryState extends EntityState<CountryEntity> {
  loaded: boolean; // has the Country list been loaded
  error?: string | null; // last known error (if any)
}

export interface CountryPartialState {
  readonly [COUNTRY_FEATURE_KEY]: CountryState;
}

export const countryAdapter: EntityAdapter<CountryEntity> = createEntityAdapter<CountryEntity>();

export const initialCountryState: CountryState = countryAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const reducer = createReducer(
  initialCountryState,
  on(CountryActions.init, state => ({ ...state, loaded: false, error: null })),
  on(CountryActions.loadSuccess, (state, { entities }) => countryAdapter.setAll(entities, { ...state, loaded: true })),
  on(CountryActions.loadFailure, (state, { error }) => ({ ...state, error })),
);

export function countryReducer(state: CountryState | undefined, action: Action) {
  return reducer(state, action);
}
